import React, { createContext, useContext, useState, useCallback } from 'react';
import { ToastNotification } from '../components/ToastNotification';

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    isVisible: false,
    type: 'success',
    message: '',
    addonText: ''
  });

  const showToast = useCallback((type, message, addonText = '') => {
    setToast({
      isVisible: true,
      type,
      message,
      addonText
    });
  }, []);

  const hideToast = useCallback(() => {
    setToast(prev => ({ ...prev, isVisible: false }));
  }, []);

  // Convenience methods matching common toast patterns
  const toastMethods = {
    success: (message, addonText) => showToast('success', message, addonText),
    error: (message, addonText) => showToast('error', message, addonText),
    warning: (message, addonText) => showToast('warning', message, addonText),
    info: (message, addonText) => showToast('brand', message, addonText),
    gray: (message, addonText) => showToast('gray', message, addonText),
    show: showToast,
    hide: hideToast
  };

  return (
    <ToastContext.Provider value={toastMethods}>
      {children}
      <ToastNotification
        type={toast.type}
        message={toast.message}
        addonText={toast.addonText}
        isVisible={toast.isVisible}
        onClose={hideToast}
      />
    </ToastContext.Provider>
  );
};

export const useToastNotification = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToastNotification must be used within a ToastProvider');
  }
  return context;
};

export default ToastContext;
